import { render, staticRenderFns } from "./custom-mgt-person.vue?vue&type=template&id=a01210a2&"
import script from "./custom-mgt-person.vue?vue&type=script&lang=ts&"
export * from "./custom-mgt-person.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports